export default function Leaderboad({ leaderboardData }) {
  return (
    <div className="row gy-5 g-xl-5">
      <div className="col-xl-12">
        <div className="card card-flush h-lg-100">
          <div className="card-body p-5 ">
            <div className="d-flex flex-stack">
              <div className="d-flex flex-stack flex-row-fluid d-grid gap-2 px-2">
                <div className="me-5">
                  <span className="text-gray-600 fw-semibold fs-5 d-block text-start ps-0">
                    Members
                  </span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="text-gray-600 fw-bold fs-5 me-3 d-block">
                    Score
                  </span>
                </div>
              </div>
            </div>

            <div className="separator separator-dashed my-3" />
            <div className="m-0 leaderboard-list">
              {leaderboardData.length > 0
                && leaderboardData
                && leaderboardData.map((item) => (
                  <>
                    <div className="d-flex flex-stack">
                      <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                        <div className="symbol-label solid fs-3 bg-light-primary text-primary">
                          {item?.name.charAt(0) }
                        </div>
                      </div>
                      <div className="d-flex flex-stack flex-row-fluid d-grid gap-2">
                        <div className="me-5">
                          <a
                            href="#"
                            className="text-gray-800 fw-bold text-hover-primary fs-6"
                          >
                            {item?.name}
                          </a>
                          <span
                            className="text-gray-500 fw-semibold fs-7 d-block text-start ps-0"
                          >
                            {item?.email}
                          </span>
                        </div>
                        <div className="d-flex align-items-center">
                          <span className="text-primary fw-bold fs-2 me-3 d-block">
                            {Math.round(item?.score)}<span className="text-primary">%</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="separator separator-dashed my-3" />
                  </>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
